import {
    Component,
    OnInit
} from '@angular/core';
import {
    ActivatedRoute, Router
} from '@angular/router'
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowPartnerService } from '../workflow-partner.service';
import { firstValueFrom } from 'rxjs';
import { WorkflowComponent } from '../../workflow.component';


@Component({
    selector: 'app-workflow-partner-one-availability-order-cancel',
    templateUrl: './workflow-partner-one-availability-order-cancel.component.html',
    standalone: false
})
export class WorkflowPartnerOneAvailabilityOrderCancelComponent extends WorkflowComponent implements OnInit {

    public subscription: Subscription;
    public readonly productPremium = "PC-ONE-PREMIUM";
    public readonly productCancelPremium = "PC-ONE-CANCEL-PREMIUM";

    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowPartnerService: WorkflowPartnerService,
    ) {
        super();

    }


    async ngOnInit() {
        super.ngOnInit();
        this.setStep('order-cancel');
        if (this.applianceId && !this.subscription) {
            this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe(async r => {
                this.subscription = Subscription.fromJson(r);
            });
        }
    }

    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        try {
            const orderWithPremium = this.subscription?.orders?.find(order => 
                order?.lines?.some(line => 
                    line?.product === this.productPremium || 
                    line?.product === this.productCancelPremium
                )
            );

            if (orderWithPremium) {
                await firstValueFrom(this.workflowPartnerService.oneApplianceCancelPremium(orderWithPremium.name));
            }
            
            this.resetWorkflow();
        } catch (e) {
            console.error('Cancel premium failed', e);
            this.resetWorkflow();
        }
    }


}
